<template>
  <div v-if="isShow" id="bottomBtn" @click="goHome"><img src="@/assets/images/template/toolbar_home.png"></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ToHome',
  props: [
    'show'
  ],
  computed: {
    ...mapState(['pageType'])
  },
  watch: {
    show: {
      handler(value) {
        this.isShow = value
      }
    }
  },
  data() {
    return {
      isShow: this.show ? this.show : true
    }
  },
  mounted() {
    if (this.pageType == 'app') this.isShow = false
  },
  methods: {
    goHome() {
      this.$bus.$emit('loading', false)
      this.$router.replace({ path: '/home' })
    }
  }
}
</script>
